class Header {
  constructor(el,opt){
    this.el = el;
    this.header = document.querySelector('.l-header');
    this.mvSection = document.querySelector('.s-mv');
    this.scrollThreshold = 0;
    this.scrollPosition = 0; // スクロール位置を保存する変数を追加
    this.init();
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  init() {
    // s-mvセクションの下面から20px上の位置を計算
    if (this.mvSection) {
      const mvRect = this.mvSection.getBoundingClientRect();
      const mvBottom = mvRect.bottom + window.scrollY;
      this.scrollThreshold = mvBottom - 30;
    }
    
    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // 初期状態をチェック
    this.handleScroll();
  }

  handleScroll() {
    if (!this.header || !this.mvSection) return;
    
    const scrollY = window.scrollY;
    
    // スクロール位置が閾値を超えたかチェック
    if (scrollY >= this.scrollThreshold) {
      this.header.classList.add('is-scroll');
    } else {
      this.header.classList.remove('is-scroll');
    }
    
    // スクロール位置が1px以上の場合、bodyにis-scrolledクラスを追加
    if (scrollY > 0) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }

  event(){
    // ハンバーガーメニューのトグル機能
    const hamburgerBtn = document.querySelector('.hn-btn');
    
    if (hamburgerBtn) {
      hamburgerBtn.addEventListener('click', () => {
        this.header.classList.toggle('is-active');
        
        if (document.body.classList.contains('is-fixed')) {
          // メニューを閉じる時
          document.body.classList.remove('is-fixed');
        } else {
          // メニューを開く時
          this.scrollPosition = window.scrollY; // 現在のスクロール位置を保存
          document.body.classList.add('is-fixed');
        }
      });
    }

    // メガメニューのリンクをクリックした時にメニューを閉じる
    const megaMenuLinks = document.querySelectorAll('.mega-menu-inner ul li a');
    megaMenuLinks.forEach(link => {
      link.addEventListener('click', () => {
        // メニューを閉じる
        this.header.classList.remove('is-active');
        
        if (document.body.classList.contains('is-fixed')) {
          // スクロール禁止を解除
          document.body.classList.remove('is-fixed');
        }
      });
    });
  }
}
